//[NOTE]: musim kontrolovat ci ide o editor alebo o preview, pretoze v preview je este stara funkcionalita (zavisle od noveho PR preview aktualne problem so sekvenciami), ktora je zavisla na tom aby sa texty obnovovali kazdu 0,5 sec,
// v editore tento setInterval musim skipovat pretoze na obsluhu textov v ticker-och sluzi samostatna funkcionalita ktora je prebijana tymto setIntervalom ak to nefiltrujem
import { useEffect } from "react"
import * as tweenly from "tweenly"

import { Asset } from "tweenly/dist/fetchAsset"
import { objectsForDynamicTexts } from "../../helpers/object.helpers"
import { selectUndoable } from "../../helpers/selector.helpers"
import { selectObjects } from "../../store/slices/objects.slice"
import { useAppSelector, useAppStore } from "../useRedux"

export function useCanvasTimer() {
    const store = useAppStore()
    const assets = useAppSelector((state) => state.assets.data)
    const pendingRefreshAssets = useAppSelector((state) => state.assets.pendingRefreshAssets)
    const pendingPreloadAssets = useAppSelector((state) => state.assets.pendingPreloadAssets)

    // Sync tweenly state with Redux assets (required for refreshAsset to work)
    useEffect(() => {
        tweenly.state.assets = assets as Asset[]
    }, [assets])

    const path = window.location.pathname
    const isEditor = path.startsWith("/app/editor")

    // The tick reads the CURRENT objects and assets from the store rather than taking them as
    // dependencies. As a dependency, `objects` (a fresh array from `selectObjects`) together
    // with a `filterObjects` array rebuilt on every render made the effect re-run on every
    // render of Canvas: cleanup cleared the interval, the effect started a new one, and during
    // playback — ~50 renders per second — the 500 ms timer NEVER reached its deadline, so
    // `setDynamicTexts` / `setDynamicImageUrls` did not run at all while a graphic played.
    // Reading from the store also keeps Canvas from subscribing to the whole objects slice.
    useEffect(() => {
        if (pendingRefreshAssets || pendingPreloadAssets) {
            return
        }

        const interval = setInterval(() => {
            const state = store.getState()
            const objects = selectObjects(selectUndoable(state).objects)
            const assets = state.assets.data

            tweenly.setDynamicTexts(objectsForDynamicTexts(objects, isEditor), assets as Asset[])
            tweenly.setDynamicImageUrls(objects, assets as Asset[])
        }, 500)

        return () => clearInterval(interval)
    }, [store, isEditor, pendingRefreshAssets, pendingPreloadAssets])

    // Periodic asset refresh using tweenly's built-in functionality
    useEffect(() => {
        if (pendingRefreshAssets || pendingPreloadAssets) {
            return
        }

        tweenly.startPeriodicRefresh(assets as Asset[])

        return () => {
            tweenly.stopAllPeriodicRefresh()
        }
    }, [assets, pendingRefreshAssets, pendingPreloadAssets])

    return {}
}
